document.querySelectorAll('.product-information__heading').forEach(question => {
  question.addEventListener('click', event => {
    const mq = window.matchMedia("(max-width: 750px)");
    if (mq.matches) {
      let answer = event.currentTarget.nextElementSibling;
      let caret = event.currentTarget.querySelector('svg');
      if (answer.style.height) {
        answer.style.height = null;
        caret.removeAttribute('active')
      } else {
        answer.style.height = answer.scrollHeight + "px";
        caret.setAttribute('active', '');
      }
    }
  })
})

document.querySelector('#product-information__nutrition-zoom-button').addEventListener('click', () => {
  if (window.matchMedia('(min-width: 750px)').matches) {
    document.getElementById('product-information__nutrition-zoomed').setAttribute('active', '');
    document.addEventListener('keyup', closeWithEsc);
  }
})

document.querySelector('#product-information__zoomed-close').addEventListener('click', () => {
  document.getElementById('product-information__nutrition-zoomed').removeAttribute('active');
  document.removeEventListener('keyup', closeWithEsc);
})

function closeWithEsc(e) {
  if (e.code === 'Escape') {
    document.getElementById('product-information__nutrition-zoomed').removeAttribute('active');
    document.addEventListener('keyup', closeWithEsc);
  }
}
